import { Routes, Route, Navigate } from 'react-router-dom'
import { ToastProvider } from '@/components/ui/ToastProvider'
import { ModalProvider } from '@/components/modals/ModalProvider'
import { AuthProvider } from '@/components/layout/AuthProvider'
import { AppShell } from '@/components/layout/AppShell'

// Auth pages
import LoginPage from '@/pages/auth/LoginPage'
import RegisterPage from '@/pages/auth/RegisterPage'
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage'
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage'
import AuthCallbackPage from '@/pages/auth/AuthCallbackPage'

// Main pages
import FeedPage from '@/pages/FeedPage'
import TrendingPage from '@/pages/TrendingPage'
import SearchPage from '@/pages/SearchPage'
import TopicsPage from '@/pages/TopicsPage'
import TopicDetailPage from '@/pages/TopicDetailPage'
import ProfilePage from '@/pages/ProfilePage'
import PostDetailPage from '@/pages/PostDetailPage'
import CreatePostPage from '@/pages/CreatePostPage'
import EditPostPage from '@/pages/EditPostPage'
import NotificationsPage from '@/pages/NotificationsPage'
import MessagesPage from '@/pages/MessagesPage'
import BookmarksPage from '@/pages/BookmarksPage'
import FollowingPage from '@/pages/FollowingPage'
import DashboardPage from '@/pages/DashboardPage'
import SettingsPage from '@/pages/SettingsPage'
import AboutPage from '@/pages/AboutPage'
import HelpPage from '@/pages/HelpPage'

// Admin pages
import AdminPage from '@/pages/admin/AdminPage'
import AdminUsersPage from '@/pages/admin/AdminUsersPage'
import AdminTopicsPage from '@/pages/admin/AdminTopicsPage'
import AdminModerationPage from '@/pages/admin/AdminModerationPage'
import AdminAnalyticsPage from '@/pages/admin/AdminAnalyticsPage'

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ModalProvider>
          <Routes>
            {/* Auth routes - no shell */}
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/register" element={<RegisterPage />} />
            <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />

            {/* App routes - with shell */}
            <Route element={<AppShell />}>
              <Route path="/" element={<Navigate to="/feed" replace />} />
              <Route path="/feed" element={<FeedPage />} />
              <Route path="/trending" element={<TrendingPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/topics" element={<TopicsPage />} />
              <Route path="/topics/:slug" element={<TopicDetailPage />} />
              <Route path="/profile/:username" element={<ProfilePage />} />
              <Route path="/post/:id/:slug?" element={<PostDetailPage />} />
              <Route path="/post/create" element={<CreatePostPage />} />
              <Route path="/post/edit/:id" element={<EditPostPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/bookmarks" element={<BookmarksPage />} />
              <Route path="/following" element={<FollowingPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/help" element={<HelpPage />} />

              {/* Admin */}
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/topics" element={<AdminTopicsPage />} />
              <Route path="/admin/moderation" element={<AdminModerationPage />} />
              <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/feed" replace />} />
          </Routes>
        </ModalProvider>
      </ToastProvider>
    </AuthProvider>
  )
}
